// 常见问题数据（与 FAQPage 结构化数据保持一致）

export interface FaqItem {
  id: string;
  q: string;
  a: string;
  tag: string;
}

export const faqItems: FaqItem[] = [
  {
    id: "faq-1",
    tag: "概念",
    q: "什么是明星塌房？塌房与一般的负面新闻有什么区别？",
    a: "明星塌房指艺人长期建立的正面人设因某一突发事件在短时间内崩塌，粉丝与大众集体产生幻灭感的现象。与普通负面新闻不同，塌房常伴随人设与真相的强烈反差，会触发大面积脱粉与舆论情绪翻转。",
  },
  {
    id: "faq-2",
    tag: "反应",
    q: "脱粉和回踩是一回事吗？",
    a: "不是。脱粉是停止喜欢、取关删号等单方面冷却行为；回踩是脱粉后主动翻旧账、晒证据、发长文复盘，甚至主动参与传播负面，属于由爱转恨、态度更强的行为。",
  },
  {
    id: "faq-3",
    tag: "站姐",
    q: "为什么塌房后站姐容易跑路或关站？",
    a: "站姐常以官方应援、前线物料为主要投入，一旦塌房，账号信任价值、物料收益与个人名誉都会受牵连。部分站子会沉默删号，也有少数清理后改做回忆向，或直接停更退出。",
  },
  {
    id: "faq-4",
    tag: "超话",
    q: "超话为什么会失守？主持人起什么作用？",
    a: "超话是粉丝聚集地与数据阵地，塌房后管理员话语体系与粉丝诉求可能分裂，出现大规模退出、更换主持或广场被反方内容占据的情况，即超话失守。主持人是审核与排播核心，立场不稳会加速失守。",
  },
  {
    id: "faq-5",
    tag: "心理",
    q: "塌房后粉丝一般要多久才能走出来？",
    a: "没有统一答案。常见轨迹是事件爆发期情绪最激烈、脱粉回踩集中；一两周内逐渐分化为继续支持、彻底脱粉、转为路人三种阵营；真正的心态稳定往往需要数月甚至更久。",
  },
  {
    id: "faq-6",
    tag: "建议",
    q: "吃瓜时如何分辨消息真伪、避免被带节奏？",
    a: "建议以官方通报、多方信源与时间线交叉验证为准；警惕只有截图或匿名爆料的单一信源；同时区分事实指控与情绪揣测，塌房话题情绪浓烈，更需要冷静判断。",
  },
];